exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-buy {\n  padding: 10px;\n  border: 1px dotted #f52606;\n}\n.alert {\n  margin-top: 10px;\n}\n.checkbox-wrap {\n  border: 1px dotted #c3c5c6;\n  padding: 10px;\n  width: 100%;\n}\n/*.customTextarea:focus{*/\n/*  border-color: #ddd;*/\n/*}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/share/boxRetalStamps/boxRetalStamps.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/share/boxRetalStamps/boxRetalStamps.component.css
// module chunks = 3